import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SectionContainer.css";

class SectionContainer extends Component {
  render() {
    return (
      <div className={classNames(styles.root, this.props.className)}>
        <div className={styles.header}>
          {this.props.header}
        </div>
        {this.props.children}
      </div>
    );
  }
}

SectionContainer.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};

export default SectionContainer;



// WEBPACK FOOTER //
// ./src/components/Library/SectionContainer/SectionContainer.js